import { cn } from "@/lib/utils";
import type { SidebarClasses } from "./sidebar-theme";
import { getInitials } from "./sidebar-utils";

interface SidebarOrgCardProps {
  tenantName: string;
  typeLabel: string;
  roleLabel: string;
  classes: SidebarClasses;
}

/** Organização ativa, só informativa (S3): sem chevron e sem clique; não troca de tenant (C4). */
export function SidebarOrgCard({ tenantName, typeLabel, roleLabel, classes }: SidebarOrgCardProps) {
  const subtitle = roleLabel ? `${typeLabel} · ${roleLabel}` : typeLabel;
  return (
    <div className={cn("flex items-center gap-2.5 rounded-[10px] border py-2 pl-2 pr-2.5", classes.orgCard)}>
      <span
        aria-hidden="true"
        className={cn(
          "flex h-8 w-8 shrink-0 items-center justify-center rounded-[8px] text-[12px] font-bold leading-none",
          classes.orgAvatar,
        )}
      >
        {getInitials(tenantName)}
      </span>
      <div className="min-w-0 flex-1">
        <p className={cn("truncate text-[13px] font-semibold leading-[17px]", classes.strong)}>{tenantName}</p>
        <p className={cn("truncate text-[11px] leading-[14px]", classes.sub)}>{subtitle}</p>
      </div>
    </div>
  );
}
